import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common'
import { CloneObject } from '../../../utils/helpers'
import { isNull } from '../../../utils/validator'
import { getDateToString } from '../../../utils/convert'
import RubroAlicuotaModal from '../RubroAlicuotaModal'

const RubroAlicuotasGrid = (props) => {

    const [state, setState] = useState({
        list: [],
        showForm: false,
        modeFormEdit: false,
        rowForm: null,
        showMessage: false,
    })

    const [rangoSolapado, setRangoSolapado] = useState(null)

    const dispatch = useDispatch()
    const sequenceValue = useSelector((state) => state.sequence.value)

    useEffect(() => {
        setState(prevState => {
            const list = props.alicuotas.filter(x => x.state !== 'r')
            return { ...prevState, list }
        })
    }, [props.alicuotas])

    const cellA = () => (
        <div className='action'>
            {!props.disabled && (
                <div onClick={() => handleAdd()} className="link">
                    <span className="material-symbols-outlined" title="Nuevo">add</span>
                </div>
            )}
        </div>
    )

    const cellVMR = (data) => (
        <div className='action'>
            <div onClick={() => handleView(data.value)} className="link">
                <span className="material-symbols-outlined" title="Ver">search</span>
            </div>
            {!props.disabled && (
                <div onClick={() => handleModify(data.value)} className="link">
                    <span className="material-symbols-outlined" title="Modificar">stylus</span>
                </div>
            )}
            {!props.disabled && (
                <div onClick={() => handleRemove(data.value)} className="link">
                    <span className="material-symbols-outlined" title="Eliminar">delete</span>
                </div>
            )}
        </div>
    )

    const tableColumns = [
        { Header: 'Valor', accessor: 'valor', width: '25%' },
        { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '25%' },
        { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '25%' },
        { Header: cellA, Cell: cellVMR, id: 'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ]

    const handleAdd = () => {
        const idTemporal = (-1) * sequenceValue
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                valor: 0,
                fechaDesde: null,
                fechaHasta: null,
                state: 'a'
            }
            return { ...prevState, showForm: true, modeFormEdit: true, rowForm }
        })
        dispatch(sequenceActionNext())
    }

    const handleView = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id)
            return { ...prevState, showForm: true, modeFormEdit: false, rowForm }
        })
    }

    const handleModify = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id)
            return { ...prevState, showForm: true, modeFormEdit: true, rowForm }
        })
    }

    const handleRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id)
            return { ...prevState, showMessage: true, rowForm }
        })
    }

    function RemoveAlicuota(row) {
        if (row.state === 'a' || row.id < 0) {
            const updatedList = props.alicuotas.filter(x => x.id !== row.id)
            props.onChange(updatedList)
        } else {
            row.state = 'r'
            const updatedList = props.alicuotas.map(x => x.id === row.id ? row : x)
            props.onChange(updatedList)
        }
    }

    function UpdateAlicuota(row) {
        row.state = isNull(props.alicuotas.find(x => x.id === row.id)) ? 'a' : (row.id < 0 ? 'a' : 'm')
        const exists = props.alicuotas.find(x => x.id === row.id)
        const updatedList = exists
            ? props.alicuotas.map(x => x.id === row.id ? row : x)
            : [...props.alicuotas, row]
        props.onChange(updatedList)
    }

    function ValidateDatesConflicts(row) {
        const listOthers = state.list.filter(f => f.id !== row.id)
        const conflicts = listOthers.filter(f =>
            (f.fechaDesde <= row.fechaHasta || isNull(f.fechaDesde) || isNull(row.fechaHasta)) &&
            (f.fechaHasta >= row.fechaDesde || isNull(f.fechaHasta) || isNull(row.fechaDesde))
        )
        return (conflicts.length === 0)
    }

    return (
        <>
            {state.showMessage &&
                <MessageModal
                    title={"Confirmación"}
                    message={"¿Está seguro de borrar el registro?"}
                    onDismiss={() => {
                        setState(prevState => {
                            return { ...prevState, showMessage: false, rowForm: null }
                        })
                    }}
                    onConfirm={() => {
                        const row = CloneObject(state.rowForm)
                        setState(prevState => {
                            return { ...prevState, showMessage: false, rowForm: null }
                        })
                        RemoveAlicuota(row)
                    }}
                />
            }

            {state.showForm &&
                <RubroAlicuotaModal
                    disabled={!state.modeFormEdit}
                    alicuota={state.rowForm}
                    rangoSolapado={rangoSolapado}
                    onDismiss={() => {
                        setRangoSolapado(null)
                        setState(prevState => {
                            return { ...prevState, showForm: false, rowForm: null }
                        })
                    }}
                    onConfirm={(row) => {
                        if (ValidateDatesConflicts(row)) {
                            setRangoSolapado(null)
                            setState(prevState => {
                                return { ...prevState, showForm: false, rowForm: null }
                            })
                            UpdateAlicuota(row)
                        } else {
                            setRangoSolapado({fechaDesde: row.fechaDesde, fechaHasta: row.fechaHasta})
                        }
                    }}
                />
            }

            <TableCustom
                showFilterGlobal={false}
                showDownloadCSV={false}
                className={'TableCustomBase'}
                columns={tableColumns}
                data={state.list}
            />
        </>
    )
}

export default RubroAlicuotasGrid
